import React, { Component } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { loginAs } from '../users/loggedUser/actions';

class LoginAs extends Component {
  componentDidMount() {
    this.props.loginAs();
  }
  state = {};
  render() {
    return (
      <Dimmer page active>
        <Loader />
      </Dimmer>
    );
  }
}

export default connect(
  undefined,
  (dispatch, ownProps) => ({
    loginAs: () =>
      dispatch(
        loginAs(ownProps.location.search, () => ownProps.history.push('/'))
      )
  })
)(LoginAs);



// WEBPACK FOOTER //
// ./src/components/LoginAs.js